import { TextField } from "../../../../utils/form";

const Phone = ({ form: { control }, ...props }) => (
  <TextField
    control={control}
    name="workPhone"
    variant="outlined"
    required
    helperText={props.bgColor ? "" : "Como se mostrará en las prescripciones"}
    placeholder={props.bgColor ? "Como se mostrará en las prescripciones" : ""}
    sx={{ backgroundColor: props.bgColor && "#F2F9FF66" }}
    {...props}
    fullWidth
  />
);

export default Phone;
